// @ts-expect-error for any. This function accepts any type and will always return the same type as the input type.
const sentenceCase = (string: T): T => {
  return typeof string !== "string"
    ? string
    : string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export default sentenceCase;
